<template>
  <b-row v-if="!dataLoaded">
    <b-col>
      <Loader size="lg"></Loader>
    </b-col>
  </b-row>
  <b-row v-else>
    <b-col cols="12" class="mb-2">
      <router-link v-if="ableToEditOrganizationLead" :to="{ name: 'EXABOrganizationLeadUpdate', params: { id: item['@id'] } }" class="btn btn-default btn-sm">
        <span>{{ $t('buttons.edit') }}</span>
      </router-link>
      <button v-if="ableToEditOrganizationLead" class="btn btn-warning btn-sm" @click="archiveItem(item['@id'])">{{ $t('buttons.archive') }}</button>
      <router-link :to="{ name: 'EXABOrganizationLeadList' }" class="btn btn-sm btn-default float-right">{{$t('buttons.backToList')}}</router-link>
    </b-col>
    <b-col sm="12" lg="8">
      <b-card>
        <span v-for="tag in item.tags" :key="tag['@id']">
          <b-badge class="mr-2 mb-2 organizationleadtag" pill :style="{'background-color': tag.tag.color}"><i class="fa fa-tags mr-2"></i>{{tag.tag.tag}}</b-badge>
        </span>
        <p v-if="item.title"><b>{{$t('views.exaborganizationlead.form.title')}}: </b><span>{{item.title}}</span></p>
        <p v-if="item.description"><b>{{$t('views.exaborganizationlead.form.description')}}: </b><span>{{item.description}}</span></p>
        <p v-if="item.createdAt"><b>{{$t('views.excmcase.show.created')}}: </b><span>{{$moment(item.createdAt).format('YYYY-MM-DD HH:mm')}}</span></p>
        <p v-if="item.idUserData"><b>{{$t('views.exaborganizationlead.form.idUserData')}}</b>:
          <router-link v-if="item.idUserData && item.idUserData.isCompany === 0" :to="{name: 'UserDataShow', params: { id: item.idUserData['@id'] }}">
            {{ item.idUserData.name }} {{ item.idUserData.surname }}
          </router-link>
          <router-link v-else-if="item.idUserData" :to="{name: 'FirmShow', params: { id: item.idUserData['@id'] }}">
            {{ item.idUserData.firmname1 === '' ? item.idUserData.fullName : item.idUserData.firmname1 }}
          </router-link>
        </p>
        <p v-if="item.idSalesRepresentative"><b>{{$t('views.exaborganizationlead.form.idSalesRepresentative')}}: </b>
          <router-link :to="{name: 'UserDataShow', params: { id: item.idSalesRepresentative['@id'] }}">
            {{ item.idSalesRepresentative.name }} {{ item.idSalesRepresentative.surname }}
          </router-link>
        </p>
        <p v-if="item.idStatus"><b>{{$t('views.exaborganizationlead.form.idStatus')}}: </b><span>{{item.idStatus.title}}</span></p>
        <p v-if="item.idSalesOpportunity"><b>{{$t('views.exaborganizationlead.form.idSalesOpportunity')}}: </b><span>{{item.idSalesOpportunity.title}}</span></p>
        <p v-if="item.yearlyCost"><b>{{$t('views.exaborganizationlead.form.yearlyCost')}}: </b><span>{{item.yearlyCost}}</span></p>
        <p v-if="item.monthlyCost"><b>{{$t('views.exaborganizationlead.form.monthlyCost')}}: </b><span>{{item.monthlyCost}}</span></p>
        <p v-if="item.salesOpportunities && item.salesOpportunities.length > 0"><b>{{ $t('views.firm.form.idOpportunity') }}</b>:</p>
        <p v-for="(salesOpportunity, salesOpportunityIndex) in item.salesOpportunities" :key="'salesOpportunity' + salesOpportunityIndex"><i v-b-tooltip.hover :title="$t('views.firm.form.idOpportunity') + ': ' + salesOpportunity.idSalesOpportunity.title" :style="'color: ' + salesOpportunity.idSalesOpportunity.color" class="fa fa-circle fa-lg mr-2"></i>{{salesOpportunity.idSalesOpportunity.title}} {{ $t('global.smFrom') }} {{ $moment(salesOpportunity.createdAt).format('YYYY-MM-DD') }} <span v-if="salesOpportunity.dateTo">{{ $t('global.smTo') }} {{$moment(salesOpportunity.dateTo).format('YYYY-MM-DD')}}</span></p>
        <p v-if="item.statuses && item.statuses.length > 0"><b>{{ $t('views.firm.form.idStatus') }}</b>:</p>
        <p v-for="(status, statusIndex) in item.statuses" :key="'status' + statusIndex"><i v-b-tooltip.hover :title="$t('views.firm.form.idStatus') + ': ' + status.idStatus.title" :style="'color: ' + status.idStatus.color" class="fa fa-circle fa-lg mr-2"></i>{{status.idStatus.title}} {{ $t('global.smFrom') }} {{ $moment(status.createdAt).format('YYYY-MM-DD') }} <span v-if="status.dateTo">{{ $t('global.smTo') }} {{$moment(status.dateTo).format('YYYY-MM-DD')}}</span></p>
      </b-card>
      <b-card v-if="item">
        <b-col>
          <timetable-notes
            :id-organization-lead="item['@id']"
            @noteAdded="fetchData()"></timetable-notes>
        </b-col>
      </b-card>
      <b-row v-if="item && ableToShowRelations">
        <b-col lg="6" md="12">
          <b-card>
            <b-col>
              <upcoming-relations
                :id-organization-lead="idOrganizationLead"
                @relationAdded="fetchData()"
              ></upcoming-relations>
            </b-col>
          </b-card>
        </b-col>
        <b-col lg="6" md="12">
          <b-card>
            <b-col>
              <upcoming-relations
                :id-organization-lead="idOrganizationLead"
                :contact-type="2"
                @relationAdded="fetchData()"
              ></upcoming-relations>
            </b-col>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
    <b-col sm="12" lg="4">
      <time-line type="simple">
        <time-line-item class="timeline-panel-organizationlead" inverted :badge-icon="timelineItem.icon" v-for="(timelineItem, index) in timeline" :key="'timeline' + index">
          <p slot="header" v-if="timelineItem.type === 'status'"><b>{{$t('views.exaborganizationlead.timeline.newStatus')}}</b></p>
          <p slot="header" v-else-if="timelineItem.type === 'salesOpportunity'"><b>{{$t('views.exaborganizationlead.timeline.newSalesOpportunity')}}</b></p>
          <p slot="header" v-else-if="timelineItem.type === 'note'"><b>{{$t('views.exaborganizationlead.timeline.newNote')}}</b></p>
          <p slot="header" v-else-if="timelineItem.type === 'meeting'"><b>{{$t('views.exaborganizationlead.timeline.newMeeting')}}</b></p>
          <p slot="header" v-else-if="timelineItem.type === 'phone'"><b>{{$t('views.exaborganizationlead.timeline.newPhone')}}</b></p>
          <b-badge slot="header" class="organizationleadtag" pill v-if="timelineItem.type === 'status'" :style="{'background-color': timelineItem.status.idStatus.color}">{{timelineItem.status.idStatus.title}}</b-badge>
          <b-badge slot="header" class="organizationleadtag" pill v-else-if="timelineItem.type === 'salesOpportunity'" :style="{'background-color': timelineItem.salesOpportunity.idSalesOpportunity.color}">{{timelineItem.salesOpportunity.idSalesOpportunity.title}}</b-badge>
          <span slot="header" v-else-if="timelineItem.type === 'note'">{{timelineItem.note.title}}</span>
          <span slot="header" v-else-if="timelineItem.type === 'meeting' || timelineItem.type === 'phone'">{{timelineItem.relation.title}} <p v-if="timelineItem.relation.dateFrom">{{$t('views.excmcase.show.deadline')}}: {{$moment(timelineItem.relation.dateFrom).format('YYYY-MM-DD HH:mm')}}</p></span>
          <small slot="footer">{{$t('views.excmcase.show.created')}} - {{$moment(timelineItem.date).format('YYYY-MM-DD HH:mm')}}</small>
        </time-line-item>
      </time-line>
    </b-col>
    <PhoneCreateModal :id-organization-lead="item['@id']"></PhoneCreateModal>
    <MeetingCreateModal :id-organization-lead="item['@id']"></MeetingCreateModal>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Loader from '../../../Layout/Loader'
import TimeLine from '@/components/UIComponents/TimeLine/TimeLine.vue'
import TimeLineItem from '@/components/UIComponents/TimeLine/TimeLineItem.vue'
import UpcomingRelations from '@/components/Dashboard/Views/common/UpcomingRelations.vue'
import TimetableNotes from '@/components/Dashboard/Views/common/TimetableNotes.vue'
import { checkPermission } from '@/utils/checkRoles'
import getId from '@/utils/getIdFromLink'
import PhoneCreateModal from '@/components/Dashboard/Views/excmrelation/modals/PhoneCreateModal.vue'
import MeetingCreateModal from '@/components/Dashboard/Views/excmrelation/modals/MeetingCreateModal.vue'
import { archive } from '@/utils/archive'

export default {
  components: {
    MeetingCreateModal,
    PhoneCreateModal,
    TimetableNotes,
    UpcomingRelations,
    Loader,
    TimeLine,
    TimeLineItem
  },
  data () {
    return {
      dataLoaded: false
    }
  },
  watch: {
    isLoading (val) {
      if (!val && this.dataLoaded === false) {
        this.dataLoaded = true
      }
    }
  },
  computed: {
    idOrganizationLead () {
      return parseInt(getId(this.item['@id']))
    },
    ableToShowRelations () {
      return checkPermission('firms', 'EXCMRelationsList')
    },
    ableToEditOrganizationLead () {
      return checkPermission('firms', 'EXABOrganizationLeadUpdate')
    },
    ...mapGetters({
      deleteError: 'exaborganizationlead/del/error',
      error: 'exaborganizationlead/show/error',
      isLoading: 'exaborganizationlead/show/isLoading',
      item: 'exaborganizationlead/show/retrieved'
    }),
    timeline () {
      let timeline = []
      for (let i in this.item.statuses) {
        timeline.push({
          icon: 'fa fa-spinner fa-lg mt-2',
          type: 'status',
          status: this.item.statuses[i],
          date: this.item.statuses[i].createdAt
        })
      }
      for (let i in this.item.salesOpportunities) {
        timeline.push({
          icon: 'fa fa-trophy fa-lg mt-2',
          type: 'salesOpportunity',
          salesOpportunity: this.item.salesOpportunities[i],
          date: this.item.salesOpportunities[i].createdAt
        })
      }
      for (let i in this.item.notes) {
        timeline.push({
          icon: 'fa fa-sticky-note fa-lg mt-2',
          type: 'note',
          note: this.item.notes[i],
          date: this.item.notes[i].createdAt
        })
      }
      for (let i in this.item.relations) {
        if (this.item.relations[i].contactType === 1) {
          timeline.push({
            icon: 'fa fa-handshake fa-lg mt-2',
            type: 'meeting',
            relation: this.item.relations[i],
            date: this.item.relations[i].createdAt
          })
        } else if (this.item.relations[i].contactType === 2) {
          timeline.push({
            icon: 'fa fa-phone fa-lg mt-2',
            type: 'phone',
            relation: this.item.relations[i],
            date: this.item.relations[i].createdAt
          })
        }
      }
      // Posortowane po dacie
      timeline.sort((a, b) => {
        return new Date(a.date) - new Date(b.date)
      })
      return timeline
    }
  },
  beforeDestroy () {
    this.reset()
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.retrieve(decodeURIComponent(this.$route.params.id))
    },
    archiveItem (id) {
      archive(id, () => { this.fetchData() })
    },
    ...mapActions({
      del: 'exaborganizationlead/del/del',
      reset: 'exaborganizationlead/show/reset',
      retrieve: 'exaborganizationlead/show/retrieve'
    })
  }
}
</script>
